import { registerQuery } from 'data-fetching-client';
import noAuthHttp from 'hub-http/clients/noAuthApiClient';
import { getPublicCurrencyV2Rpc } from 'pricing-pages-ui-public-app/__generated__/chirp/com/hubspot/buying/rpc/PublicProductRpc';
import { createRpcClientV2 } from 'rpc-client-utils';
import { getChirpEarlyRequest, normaliseCurrencyRequest } from '../utils/earlyRequest';
import { getCurrencyStoreResponse } from '../utils/currencyDataTransformer';
const rpcClientNoAuth = createRpcClientV2({
  hubHttpClient: noAuthHttp
});
export const GET_PUBLIC_CURRENCIES = registerQuery({
  fieldName: 'currencies',
  args: ['preferredCountryCode', 'browserLocale'],
  fetcher({
    browserLocale,
    preferredCountryCode
  }) {
    // Must use the same normaliser as the early requester so the hash matches
    // and we hit the warmed cache instead of falling back to a fresh RPC call.
    const request = normaliseCurrencyRequest({
      browserLocale,
      preferredCountryCode: preferredCountryCode
    });
    return getChirpEarlyRequest({
      details: Object.assign({}, getPublicCurrencyV2Rpc, {
        earlyRequest: true
      }),
      requestObject: {
        request
      },
      fallbackFetcher: () => rpcClientNoAuth.call(getPublicCurrencyV2Rpc, {
        request: request
      })
    }).then(response => {
      // Type cast necessary: Using structural typing to handle both CHIRP V2 and REST responses.
      // UnifiedCurrencyResponse accepts both null (REST) and undefined (CHIRP) for optional fields.
      // Type guards (isCurrencyCodeString, isCountryCodeString) provide runtime validation.
      return getCurrencyStoreResponse(response);
    }).catch(error => {
      console.error('Failed to fetch public currencies:', error);
      throw error;
    });
  }
});